import styled from 'styled-components'
import { themeGet } from 'styled-system'

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  background-color: ${themeGet('globalNav.backgroundColor')};
  height: 50px;
  position: relative;
  z-index: 1;
`

export const Title = styled.span`
  color: ${themeGet('colors.white')};
  font-family: ${themeGet('headerFontFamilySemibold')};
  font-size: 21px;
`

export const TitleContainer = styled.div`
  margin-left: 4.6875rem;
  margin-top: 0.3125rem;
  display: flex;
  justify-content: center;
  align-items: center;
`
